import _ from 'lodash';

function formatServerErrorMessage(error) {
    if (!error) {
        return null;
    }

    if (typeof error === 'string') {
        return error;
    }

    if (error instanceof Error) {
        return error.message;
    }

    if (error.field || error.message) {
        return `${error.field || ''} ${String(error.message || '').toLowerCase()}`.trim();
    }

    return null;
}

function getGlobalErrorMessages(poisEditorState) {
    const uiErrors = _.get(poisEditorState, 'uiErrors', []);
    const serverSaveErrors = _.get(poisEditorState, 'serverSaveErrors', []);

    const formattedServerErrors = Array.isArray(serverSaveErrors)
        ? serverSaveErrors.map(formatServerErrorMessage)
        : [];

    return _.uniq([].concat(uiErrors, formattedServerErrors).filter(Boolean));
}

export default function selector(storeState) {
    const poisEditorState = _.get(storeState, 'poisEditor');
    const poiActionsState = _.get(storeState, 'resources.pois');
    const ownOrgId = _.get(storeState, 'profile.organizationId');
    const geoResources = _.get(storeState, 'resources.geoCategories');

    return {
        poisEditorState,
        poiActionsState,
        ownOrgId,
        geoResources,
        globalErrorMessages: getGlobalErrorMessages(poisEditorState),
    };
}
